export default "__VITE_PUBLIC_ASSET__877fe9fc__"